import Vue from "vue";
import Router from "vue-router";
// import goaltracking from '@/components/attendanceemployee'
import settings from "@/components/settings";

import profile from "@/components/profile";
// import clientprofile from '@/components/clientprofile'
import error404 from "@/components/error404";
import error500 from "@/components/error500";

import index from "@/views/dashboard/index";
import summaryproducts from "@/views/monitoring/summary/index";
import summaryreport from "@/views/monitoring/summary/report";
import summary from "@/views/monitoring/summary/indexsummary";
import instagramDashboard from "@/views/dashboard/instagramDashboard";

import faq from "@/components/faq";
import terms from "@/components/terms";
import privacypolicy from "@/components/privacypolicy";

import changepassword from "@/components/changepassword";
import localization from "@/components/localization";
import loginPage from "./modules/login";

import register from "@/views/register";
import otpConfirm from "@/views/register/confirm";
import forgotRequest from "@/views/forgot";
import forgotCheck from "@/views/forgot/check";
import brands from "@/views/monitoring/brands/list";
import store from "@/views/monitoring/store/list";
import products from "@/views/monitoring/products/list";
import agents from "@/views/monitoring/agents/list";
import agentRoles from "@/views/monitoring/agents/roles";
import instagramAccount from "@/views/instagram/instagramAccount/list";
import instagramAccountOfficial from "@/views/instagram/instagramAccount/listOfficial";
import monitoringLinkList from "@/views/monitoring/links/list";
import monitoringBookmarkList from "@/views/monitoring/links/listBookmark";
import monitoringTrashList from "@/views/monitoring/links/trash";
import monitoringLogList from "@/views/monitoring/logs/list";
import monitoringScrapingWizard from "@/views/monitoring/scrape/wizard";
import monitoringScrapingList from "@/views/monitoring/scrape/list";
import instagramScheduleList from "@/views/instagram/instagramSchedule/list";
import instagramScheduleListOfficial from "@/views/instagram/instagramScheduleOfficial/list";
import instagramScheduleListOfficialStatistik from "@/views/instagram/instagramScheduleOfficial/statistik";
import instagramLogsList from "@/views/instagram/instagramLogs/list";
import instagramLogsListOfficial from "@/views/instagram/instagramLogsOfficial/list";
import instagramScheduleWizard from "@/views/instagram/instagramSchedule/wizard";
import instagramScheduleWizardOfficial from "@/views/instagram/instagramScheduleOfficial/wizard";
import officialContentPublishing from "@/views/instagram/instagramAccount/officialContentPublishing";
import officialFullAccess from "@/views/instagram/instagramAccount/officialFullAccess";

import instagramAnalyticsProfile from "@/views/instagram/instagramAnalytics/profile";
import instagramAnalyticsPosts from "@/views/instagram/instagramAnalytics/posts";
import instagramAnalyticsMedia from "@/views/instagram/instagramAnalytics/mediaOff";

// Agent
import indexAgent from "@/views/dashboard/indexAgent";
import summaryreportAgent from "@/views/monitoring/summary/reportAgent";
import summaryAgent from "@/views/monitoring/summary/indexsummaryAgent";
import summaryproductsAgent from "@/views/monitoring/summary/indexAgent";
import monitoringLinkListAgent from "@/views/monitoring/links/listAgent"; 
//walletconnect
import walletConnectList from "@/views/walletconnect/list";


Vue.use(Router);

export const constantRoutes = [
  {
    path: "/redirect",
    hidden: true,
    children: [
      {
        path: "/redirect/:path*",
        component: () => import("@/views/redirect/index")
      }
    ]
  },
  {
    path: "/register",
    name: "register",
    meta: {
      title: "Registration"
    },
    hidden: false,
    component: register
  },
  {
    path: "/register/confirm",
    name: "otpConfirm",
    meta: {
      title: "Registration OTP"
    },
    hidden: false,
    component: otpConfirm
  },
  {
    path: "/forgotpassword",
    name: "forgotpassword",
    meta: {
      title: "Forgot Password"
    },
    hidden: false,
    component: forgotRequest
  },
  {
    path: "/forgotpassword/check",
    name: "forgotpasswordcheck",
    meta: {
      title: "Forgot Password"
    },
    hidden: false,
    component: forgotCheck
  },
  loginPage,
  {
    path: "/error404",
    name: "error404",
    hidden: true,
    component: error404
  },
  {
    path: "/error500",
    name: "error500",
    hidden: true,

    component: error500
  },
  {
    path: "/sign-agent",
    meta: {
      title: "Sign Agent"
    },
    name: "sign-agent",
    component: () => import("@/views/login/agent")
  }
];
//   ,
//   linkActiveClass: "active",
// })

export const asyncRoutes = [
  /** when your routing map is too long, you can split it into small modules **/
  // 404 page must be placed at the end !!!
  {
    meta: {
      title: "Wallet Connect"
      // roles: ['member']
    },
    hidden: false,
    path: "/wallconn/list",
    name: "wallcon_list",
    component: walletConnectList
  },
  {
    meta: {
      roles: ["agent"]
    },
    hidden: false,
    path: "/index-agent",
    name: "index_agent",
    component: indexAgent
  },
  {
    meta: {
      roles: ["agent"]
    },
    hidden: false,
    path: "/statistik-agent/harian",
    name: "summaryreport_agent",
    component: summaryreportAgent
  },
  {
    meta: {
      roles: ["agent"]
    },
    hidden: false,
    path: "/statistik-agent/brands",
    name: "summary_agent",
    component: summaryAgent
  },
  {
    meta: {
      roles: ["agent"]
    },
    hidden: false,
    path: "/statistik-agent/products",
    name: "summaryproducts_agent",
    component: summaryproductsAgent
  },
  {
    meta: {
      title: "Links Monitoring",
      roles: ["agent"]
      // roles: ['member']
    },
    hidden: false,
    path: "/monitoring-agent/links/list",
    name: "monitoring_agent_links_list",
    component: monitoringLinkListAgent
  },
  {
    meta: {
      title: "Dashboard Instagram"
      // roles: ['member']
    },
    hidden: false,
    path: "/instagram",
    name: "instagram_dashboard",
    component: instagramDashboard
  },
  {
    meta: {
      title: "Instagram Analytics - Profile"
      // roles: ['member']
    },
    hidden: false,
    path: "/instagram/analytics/profile",
    name: "instagram_analytics_profile",
    component: instagramAnalyticsProfile
  },
  {
    meta: {
      title: "Instagram Analytics - Posts"
      // roles: ['member']
    },
    hidden: false,
    path: "/instagram/analytics/posts",
    name: "instagram_analytics_posts",
    component: instagramAnalyticsPosts
  },
  {
    meta: {
      title: "Instagram Analytics - Media"
      // roles: ['member']
    },
    hidden: false,
    path: "/instagram/analytics/media",
    name: "instagram_analytics_media",
    component: instagramAnalyticsMedia
  },
  {
    meta: {
      title: "Post Schedule"
      // roles: ['member']
    },
    hidden: false,
    path: "/instagram/post/wizard",
    name: "instagram_post_wizard",
    component: instagramScheduleWizard
  },
  {
    meta: {
      title: "List Post Schedule",
      roles: ["member"]
    },
    hidden: false,
    path: "/instagram/post/list",
    name: "instagram_post_schedule",
    component: instagramScheduleList
  },
  {
    meta: {
      title: "Post Schedule Official"
      // roles: ['member']
    },
    hidden: false,
    path: "/instagram-official/post/wizard",
    name: "instagram_post_wizard",
    component: instagramScheduleWizardOfficial
  },
  {
    meta: {
      title: "List Post Schedule Official",
      roles: ["member"]
    },
    hidden: false,
    path: "/instagram-official/post/list",
    name: "instagram_post_schedule",
    component: instagramScheduleListOfficial
  },
  {
    meta: {
      title: "Post Statistik",
      roles: ["member"]
    },
    hidden: false,
    path: "/instagram-official/post/statistik",
    name: "instagram_post_schedule_statistik",
    component: instagramScheduleListOfficialStatistik
  },
  {
    meta: {
      title: "Logs",
      roles: ["member"]
    },
    hidden: false,
    path: "/instagram/logs/list",
    name: "instagram_logs_list",
    component: instagramLogsList
  },
  {
    meta: {
      title: "Logs Official",
      roles: ["member"]
    },
    hidden: false,
    path: "/instagram-official/logs/list",
    name: "instagram_logs_list",
    component: instagramLogsListOfficial
  },
  {
    meta: {
      title: "Instagram Unofficial Accounts",
      roles: ["member"]
    },
    hidden: false,
    path: "/instagram/accounts/list",
    name: "instagram_accounts_list",
    component: instagramAccount
  },
  {
    meta: {
      title: "Instagram Official Accounts",
      roles: ["member"]
    },
    hidden: false,
    path: "/instagram/accounts/list_official",
    name: "instagram_accounts_list_official",
    component: instagramAccountOfficial
  },
  {
    meta: {
      title: "Instagram Accounts — Official Content Publishing",
      roles: ["member"]
    },
    hidden: false,
    path: "/instagram/accounts/official/add/content_publishing",
    name: "instagram_official_content_publishing",
    component: officialContentPublishing
  },
  {
    meta: {
      title: "Instagram Accounts — Official Full Access",
      roles: ["member"]
    },
    hidden: false,
    path: "/instagram/accounts/official/add/full_access",
    name: "instagram_official_full_access",
    component: officialFullAccess
  },
  {
    meta: {
      title: "Scrape"
      // roles: ['member']
    },
    hidden: false,
    path: "/monitoring/scrape/wizard",
    name: "monitoring_scrape_wizard",
    component: monitoringScrapingWizard
  },
  {
    meta: {
      title: "List Scraping"
      // roles: ['member']
    },
    hidden: false,
    path: "/monitoring/scrape/list",
    name: "monitoring_scrape_list",
    component: monitoringScrapingList
  },
  {
    meta: {
      title: "Logs Monitoring"
      // roles: ['member']
    },
    hidden: false,
    path: "/monitoring/logs/list",
    name: "monitoring_logs_list",
    component: monitoringLogList
  },
  {
    meta: {
      title: "Links Monitoring"
      // roles: ['member']
    },
    hidden: false,
    path: "/monitoring/links/list",
    name: "monitoring_links_list",
    component: monitoringLinkList
  },
  {
    meta: {
      title: "Bookmarks Monitoring"
      // roles: ['member']
    },
    hidden: false,
    path: "/monitoring/bookmarks/list",
    name: "monitoring_bookmarks_list",
    component: monitoringBookmarkList
  },
  {
    meta: {
      title: "Trash Monitoring"
      // roles: ['member']
    },
    hidden: false,
    path: "/monitoring/trash/list",
    name: "monitoring_trash_list",
    component: monitoringTrashList
  },
  {
    meta: {
      title: "Brands",
      roles: ["member"]
    },
    hidden: false,
    path: "/client/brands/list",
    name: "client_brand",
    component: brands
  },
  {
    meta: {
      title: "Products",
      roles: ["member"]
    },
    hidden: false,
    path: "/client/products/list",
    name: "client_product",
    component: products
  },
  {
    meta: {
      title: "Exclude Seller",
      roles: ["member"]
    },
    hidden: false,
    path: "/client/seller/list",
    name: "client_store",
    component: store
  },
  {
    meta: {
      title: "All Agents",
      roles: ["member"]
    },
    hidden: false,
    path: "/client/agents/list",
    name: "client_agents",
    component: agents
  },
  {
    meta: {
      title: "Agent Roles",
      roles: ["member"]
    },
    hidden: false,
    path: "/client/agents/roles",
    name: "client_profiles",
    component: agentRoles
  },
  {
    meta: {
      title: "Statistik Products",
      roles: ["member"]
    },
    hidden: false,
    path: "/statistik/products",
    name: "statistik_products",
    component: summaryproducts
  },
  {
    meta: {
      title: "Statistik Harian",
      roles: ["member"]
    },
    hidden: false,
    path: "/statistik/harian",
    name: "statistik_harian",
    component: summaryreport
  },
  {
    meta: {
      title: "Statistik Brands",
      roles: ["member"]
    },
    hidden: false,
    path: "/statistik/brands",
    name: "statistik_brands",
    component: summary
  },
  {
    path: "/faq",
    name: "faq",
    hidden: false,
    component: faq
  },
  {
    path: "/terms",
    name: "terms",
    hidden: false,
    component: terms
  },
  {
    path: "/privacypolicy",
    name: "privacypolicy",
    hidden: false,
    component: privacypolicy
  },
  {
    path: "/",
    name: "index",
    component: index
  },
  {
    path: "/index",
    hidden: false,

    name: "indexs",
    component: index
  },

  {
    hidden: false,
    meta: {
      title: "Settings",
      roles: ["member"]
    },
    path: "/settings",
    name: "settings",
    component: settings
  },
  {
    hidden: false,
    meta: {
      title: "Change Password",
      roles: ["member"]
    },
    path: "/changepassword",
    name: "changepassword",
    component: changepassword
  },
  {
    meta: {
      title: "Localization",
      roles: ["member"]
    },
    hidden: false,
    path: "/localization",
    name: "localization",
    component: localization
  },
  {
    meta: {
      title: "Profile",
      roles: ["member"]
    },
    hidden: false,
    path: "/profile",
    name: "profile",
    component: profile
  },

  {
    path: "*",
    redirect: "/error404",
    hidden: true
  }
];

const createRouter = () =>
  new Router({
    mode: "history", // require service support
    scrollBehavior: () => ({
      y: 0
    }),
    routes: constantRoutes,
    linkActiveClass: "active"
  });

const router = createRouter();

import VueGtag from "vue-gtag";
Vue.use(
  VueGtag,
  {
    config: {
      id: process.env.VUE_APP_GANALYTICS
    }
  },
  router
);

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

// export default router;
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js